import axios from 'axios';
import {
    getAuthHeader
} from "@/services/user.service.js";

export {
    GetErrorLogs,
    GetSingleLogEntry,
    GetErrorLogLevels,
    GetAuditLogs
};

function GetAuditLogs(scope, requestData, onSuccess, onError) {

    var headers = getAuthHeader();

    axios
        .post(process.env.VUE_APP_BASE_API_URL + `/auditlogentriessearch`, requestData, headers)
        .then(response => {
            onSuccess(response.data);
        })
        .catch(error => {
            onError(error);
        });
}

function GetErrorLogs(scope, requestData, onSuccess, onError) {

    var headers = getAuthHeader();

    axios
        .post(process.env.VUE_APP_BASE_API_URL + `/applications/${scope}/logentriessearch`, requestData, headers)
        .then(response => {
            onSuccess(response.data);
        })
        .catch(error => {
            onError(error);
        });
}

function GetSingleLogEntry(logEntryId, onSuccess, onError) {
    var headers = getAuthHeader();
    axios
        .get(process.env.VUE_APP_BASE_API_URL + "/logs?" + logEntryId, headers)
        .then(response => {

            if (response.data && response.data.httpResultCode == 500) {
                onError(response);
            } else {
                onSuccess(response.data);
            }
        })
        .catch(error => {
            onError(error);
        });
}

function GetErrorLogLevels(onSuccess, onError) {
    var headers = getAuthHeader();
    axios
        .get(process.env.VUE_APP_BASE_API_URL + "/loglevels", headers)
        .then(response => {
            if (response.data && response.data.httpResultCode == 500) {
                onError(response);
            } else {
                onSuccess(response.data);
            }
        })
        .catch(error => {
            onError(error);
        });
}